export default "__VITE_ASSET__DKZKFOnz__"